/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const APPROVAL_BADGE_TEXT_PENDING =
  "Deadline depends on previous action(s)";
export const APPROVAL_BADGE_TEXT_PENDING_APPROVAL = "Pending approval";
export const APPROVAL_BADGE_TEXT_NO_DEADLINE = "No approval deadline";
